import { useState, useEffect, useContext } from "react";
import "./common.scss";
import FormRendererContext from "../../services/context/FormRendererContext";

const DOB = ({ data, setAnswer, formValidation = true, formClass }) => {
  const [dateValue, setDateValue] = useState("");
  const [isValid, setIsValid] = useState(formValidation);
  const { answerData } = useContext(FormRendererContext);

  useEffect(() => {
    setIsValid(formValidation);
    
    // Check if there's an existing answer
    let existingValue = "";
    if (answerData?.[data?.key]?.value) {
      existingValue = answerData[data.key].value;
    } else if (data?.answer?.value) {
      existingValue = data.answer.value;
    }

    // If we have an existing value, try to convert it to YYYY-MM-DD format
    if (existingValue) {
      // Try to parse different date formats
      let date = null;
      
      // Try MM/DD/YYYY format first
      if (existingValue.includes('/')) {
        const [month, day, year] = existingValue.split('/');
        if (month && day && year) {
          date = new Date(year, month - 1, day);
        }
      } else {
        // Try direct parsing
        date = new Date(existingValue);
      }
      
      if (date && !isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        setDateValue(`${year}-${month}-${day}`);
        setIsValid(true);
      }
    }
  }, [data, formValidation, answerData]);

  const handleDateChange = (event) => {
    const inputValue = event.target.value; // This is in YYYY-MM-DD format
    setDateValue(inputValue);
    
    if (inputValue && inputValue.length === 10) {
      const [year, month, day] = inputValue.split('-');
      
      // Only process if year is reasonable (e.g., after 1900)
      if (parseInt(year) >= 1900) {
        const usFormat = `${month}/${day}/${year}`;
        setAnswer(data, { value: usFormat });
        setIsValid(true);
      }
    } else if (inputValue === "") {
      setAnswer(data, { value: "" });
      setIsValid(!data?.validate?.required);
    }
  };

  // Get today's date in YYYY-MM-DD format
  const getTodayString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className={`w-full ${formClass}`}>
      <div className="form-title pt-3">
        {data.label}
        {data?.validate?.required && (
          <span className={!isValid ? "text-red-700" : "text-gray-600"}>
            {" "}*
          </span>
        )}
      </div>
      <form className="flex-grow">
        <div className="radio-common date-picker my-2">
          <input
            type="date"
            value={dateValue}
            onChange={handleDateChange}
            max={data?.maxDate === "today" ? getTodayString() : undefined}
            className="text-field text-input"
          />
        </div>
      </form>
      {data?.validate?.required && !isValid && (
        <span className="text-red-700 font-light text-xs">
          {data?.invalidMessage || "Required Field"}
        </span>
      )}
    </div>
  );
};

export default DOB;


// import { useState, useEffect, useContext } from "react";
// import "./common.scss";
// import FormRendererContext from "../../services/context/FormRendererContext";

// const DOB = ({ data, setAnswer, formValidation = true, formClass }) => {
//   const [dateValue, setDateValue] = useState("");
//   const [isValid, setIsValid] = useState(formValidation);
//   const { answerData } = useContext(FormRendererContext);

//   useEffect(() => {
//     setIsValid(formValidation);
    
//     // Check if there's an existing answer
//     let existingValue = "";
//     if (answerData?.[data?.key]?.value) {
//       existingValue = answerData[data.key].value;
//     } else if (data?.answer?.value) {
//       existingValue = data.answer.value;
//     }

//     // If we have an existing value, set it directly if it's in MM/DD/YYYY format
//     if (existingValue) {
//       // Check if it's already in MM/DD/YYYY format
//       if (existingValue.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
//         setDateValue(existingValue);
//         setIsValid(true);
//       } else {
//         // Try to parse other formats and convert to MM/DD/YYYY
//         let date = null;
        
//         // Try YYYY-MM-DD format
//         if (existingValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
//           const [year, month, day] = existingValue.split('-');
//           date = new Date(year, month - 1, day);
//         } else {
//           // Try direct parsing
//           date = new Date(existingValue);
//         }
        
//         if (date && !isNaN(date.getTime())) {
//           const month = String(date.getMonth() + 1).padStart(2, '0');
//           const day = String(date.getDate()).padStart(2, '0');
//           const year = date.getFullYear();
//           setDateValue(`${month}/${day}/${year}`);
//           setIsValid(true);
//         }
//       }
//     }
//   }, [data, formValidation, answerData]);

//   const handleDateChange = (event) => {
//     const inputValue = event.target.value.replace(/[^\d\/]/g, ''); // Only allow digits and forward slashes
    
//     // Auto-format as user types
//     let formattedValue = inputValue;
    
//     // Remove any existing slashes to reformat
//     const digitsOnly = inputValue.replace(/\//g, '');
    
//     if (digitsOnly.length >= 2) {
//       formattedValue = digitsOnly.substring(0, 2);
//       if (digitsOnly.length >= 4) {
//         formattedValue += '/' + digitsOnly.substring(2, 4);
//         if (digitsOnly.length >= 8) {
//           formattedValue += '/' + digitsOnly.substring(4, 8);
//         } else if (digitsOnly.length > 4) {
//           formattedValue += '/' + digitsOnly.substring(4);
//         }
//       } else if (digitsOnly.length > 2) {
//         formattedValue += '/' + digitsOnly.substring(2);
//       }
//     }
    
//     // Limit to MM/DD/YYYY format
//     if (formattedValue.length > 10) {
//       formattedValue = formattedValue.substring(0, 10);
//     }
    
//     setDateValue(formattedValue);
    
//     // Validate the date when complete
//     if (formattedValue.length === 10 && formattedValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
//       const [month, day, year] = formattedValue.split('/');
//       const monthNum = parseInt(month);
//       const dayNum = parseInt(day);
//       const yearNum = parseInt(year);
      
//       // Basic validation
//       if (monthNum >= 1 && monthNum <= 12 && 
//           dayNum >= 1 && dayNum <= 31 && 
//           yearNum >= 1900) {
        
//         // Create date object to validate it's a real date
//         const date = new Date(yearNum, monthNum - 1, dayNum);
        
//         if (date.getFullYear() === yearNum && 
//             date.getMonth() === monthNum - 1 && 
//             date.getDate() === dayNum) {
          
//           // Check against maxDate if specified
//           if (data?.maxDate === "today") {
//             const today = new Date();
//             if (date <= today) {
//               setAnswer(data, { value: formattedValue });
//               setIsValid(true);
//             } else {
//               setIsValid(false);
//             }
//           } else {
//             setAnswer(data, { value: formattedValue });
//             setIsValid(true);
//           }
//         } else {
//           setIsValid(false);
//         }
//       } else {
//         setIsValid(false);
//       }
//     } else if (formattedValue === "") {
//       setAnswer(data, { value: "" });
//       setIsValid(!data?.validate?.required);
//     } else {
//       // Incomplete date
//       setIsValid(!data?.validate?.required || formattedValue.length === 0);
//     }
//   };

//   const handleKeyDown = (event) => {
//     // Allow: backspace, delete, tab, escape, enter
//     if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
//         // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
//         (event.keyCode === 65 && event.ctrlKey === true) ||
//         (event.keyCode === 67 && event.ctrlKey === true) ||
//         (event.keyCode === 86 && event.ctrlKey === true) ||
//         (event.keyCode === 88 && event.ctrlKey === true)) {
//       return;
//     }
//     // Ensure that it is a number or forward slash and stop the keypress
//     if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && 
//         (event.keyCode < 96 || event.keyCode > 105) && 
//         event.keyCode !== 191 && event.keyCode !== 111) {
//       event.preventDefault();
//     }
//   };

//   return (
//     <div className={`w-full ${formClass}`}>
//       <div className="form-title pt-3">
//         {data.label}
//         {data?.validate?.required && (
//           <span className={!isValid ? "text-red-700" : "text-gray-600"}>
//             {" "}*
//           </span>
//         )}
//       </div>
//       <form className="flex-grow">
//         <div className="radio-common date-picker my-2">
//           <input
//             type="text"
//             value={dateValue}
//             onChange={handleDateChange}
//             onKeyDown={handleKeyDown}
//             placeholder="MM/DD/YYYY"
//             maxLength="10"
//             className="text-field text-input"
//           />
//         </div>
//       </form>
//       {data?.validate?.required && !isValid && (
//         <span className="text-red-700 font-light text-xs">
//           {data?.invalidMessage || "Required Field"}
//         </span>
//       )}
//     </div>
//   );
// };

// export default DOB;